import moment from 'moment'
import { DefaultRoute } from '../router/routes'

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userData')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return DefaultRoute
  if (userRole === 'client') return '/access-control'
  return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})


// ** camal case to normal string

export function camelCaseToNormal(str) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .toLowerCase()
}

// ** menu name

export function getNameFromUrl() {
  const urlWithoutParams = window.location.href.split('?')[0];
  const parts = urlWithoutParams.split('/')
  // return camelCaseToNormal(parts[parts.length - 1])
  return (parts[parts.length - 1].replaceAll('-'," ")).toUpperCase()
}

// need to work on this logic for url
// export function getNameFromUrl() {
//   const parts = window.location.href.split('/')
// return parts.slice(parts.length - 2).length > 1 ? `${parts.slice(parts.length - 2)[0] } | ${parts.slice(parts.length - 2)[1]}` : `${parts.slice(parts.length - 2)[0] }`
  
//   //  (parts[parts.length - 1].replaceAll('-'," ")).toUpperCase()
// }

// **  switch case for navigation 

export const myNavigation = (parentName,navigate,data)=>{
  switch (parentName) {
    case 'home':
      navigate('/home/tricks',{state:data});
      break;                                                                                                            
    case 'tricks':
      navigate('home');
      break;
    case 'MyTricks':
        navigate('settings',{state:data});
        break;
    case 'topten':
        navigate('/my-tricks/settings',{state:data});
        break;
    default:
        navigate('home',{state:data});
      break;
  }
}


export const myDateFormat=(date,format="DD MMM YYYY")=>{
  if(date)
  {
    const fdate = new Date(date) ? new Date(date).toISOString() : new Date();

    // console.log('dddtype',fdate)
    // let fdate = (typeof date === undefined) ? "" : date

    //  console.log('dddtypef',moment(fdate).format(format))
  return moment(fdate).format(format) === "Invalid date" ? "" : moment(fdate).format(format)
  }
}

//  //Render File Size For File Upload Feature
  // const renderFileSize = (size) => {
  //   if (Math.round(size / 100) / 10 > 1000) {
  //     return `${(Math.round(size / 100) / 10000).toFixed(1)} mb`
  //   } else {
  //     return `${(Math.round(size / 100) / 10).toFixed(1)} kb`
  //   }
  // }

 export function getCurrentTime(date=null) {
  const now = new Date(date);
  const hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const amPm = hours >= 12 ? 'PM' : 'AM';
  const twelveHour = hours % 12 || 12; 
  
  return `${twelveHour}:${minutes} ${amPm}`;
}

  export function calculateGST(amount) {
    const gstRate = 0.18; // 18% GST rate
    return amount * gstRate;
  }

  // export function formatNumberWithCommas(number) {
  //   console.log('number', number)
  //   const parts = number.toFixed(2).toString().split(".");
  //   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   console.log('parts[0]', parts[0])
  //   return parts.join(",");
  // }